import loadable from '@loadable/component'
import { REFERRAL_BASE } from './pages/Referral/paths'

const routes = [
  {
    path: '/404.html',
    component: loadable(
      () => import(/* webpackChunkName: "ErrorPage" */ './pages/ErrorPage'),
    ),
  },
  {
    path: '/',
    component: loadable(
      () => import(/* webpackChunkName: "Home" */ './pages/Home/Beta'),
    ),
    exact: true,
    translated: true,
  },
  {
    path: '/signup',
    component: loadable(
      () => import(/* webpackChunkName: "SignUpPage" */ './pages/SignUpPage'),
    ),
    translated: true,
  },
  {
    path: '/contact',
    component: loadable(
      () =>
        import(/* webpackChunkName: "GetInContact" */ './pages/GetInContact'),
    ),
  },
  {
    path: '/californiaprivacyrights',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "CaliforniaPrivacyRightsPage" */ './pages/CaliforniaPrivacyRightsPage'
        ),
    ),
  },
  {
    path: '/policy',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "PrivacyPolicy" */ './pages/policy/PrivacyPolicy'
        ),
    ),
  },
  {
    path: '/policy-us',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "PrivacyPolicyUS" */ './pages/policy/PrivacyPolicyUS'
        ),
    ),
  },
  {
    path: '/policy-de',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "PrivacyPolicyUS" */ './pages/policy/PrivacyPolicyDE'
        ),
    ),
  },
  {
    path: '/policy-contact',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "PrivacyPolicyDato" */ './pages/policy/PrivacyPolicyDato'
        ),
    ),
  },
  {
    path: '/policy-hiring',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "PrivacyPolicyDato" */ './pages/policy/PrivacyPolicyDato'
        ),
    ),
  },
  {
    path: '/health-consent',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "HealthConsentDato" */ './pages/policy/HealthConsentDato'
        ),
    ),
    translated: true,
  },
  {
    path: '/three-week-weight-loss',
    // eslint-disable-next-line
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "MealPlansPage" */ './pages/MealPlansPage/MealPlansPage'
        ),
    ),
    translated: true,
  },
  {
    path: '/sugar-detox',
    // eslint-disable-next-line
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "MealPlansPage" */ './pages/MealPlansPage/MealPlansPage'
        ),
    ),
    translated: true,
  },
  {
    path: '/paleo',
    // eslint-disable-next-line
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "MealPlansPage" */ './pages/MealPlansPage/MealPlansPage'
        ),
    ),
    translated: true,
  },
  {
    path: '/how-it-works',
    // eslint-disable-next-line
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "LandingPages-General" */ './pages/LandingPages/GeneralPage'
        ),
    ),
    translated: true,
  },
  {
    path: '/how-it-works/section-preview',
    // eslint-disable-next-line
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "LandingPages-SectionPreview" */ './pages/LandingPages/SectionPreview'
        ),
    ),
    translated: true,
  },
  {
    path: '/how-it-works/:slug',
    // eslint-disable-next-line
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "LandingPages-General" */ './pages/LandingPages/GeneralPage'
        ),
    ),
    translated: true,
  },
  {
    path: '/premium',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "PremiumPage" */ './pages/PremiumPage/PremiumPage'
        ),
    ),
    translated: true,
  },
  {
    path: `/account/*`,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "UserAccount" */ './pages/UserAccount/UserAccount'
        ),
    ),
    translated: true,
  },
  {
    path: `/deleted`,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "Deleted" */ './pages/UserAccount/screens/Deleted'
        ),
    ),
    translated: true,
  },
  {
    path: `/reset/:token`,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "ResetPage" */ './pages/ResetPage/ResetPage'
        ),
    ),
    translated: true,
  },
  {
    path: `/redeem`,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "RedeemFormPage" */ './pages/Redeem/RedeemFormPage'
        ),
    ),
    translated: true,
  },
  {
    path: `/finalize-payment`,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "FinalizePaymentPage" */ './pages/FinalizePaymentPage/FinalizePaymentPage'
        ),
    ),
    translated: true,
  },
  {
    path: [`/welcome`, `/upgrade/welcome`, `/renew/welcome`, `/free/welcome`],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "WelcomePage" */ './pages/WelcomePage/WelcomePage'
        ),
    ),
    translated: true,
  },
  {
    path: `/upgrade`,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "UpgradePage" */ './pages/UpgradePage/UpgradePage'
        ),
    ),
    translated: true,
  },
  {
    path: `/upgrade/:code`,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "UpgradePage" */ './pages/UpgradePage/UpgradePage'
        ),
    ),
    translated: true,
  },
  {
    path: `/voucher/*`,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "ActivateGiftCardPage" */ './pages/ActivateGiftCardPage/ActivateGiftCardPage'
        ),
    ),
    translated: true,
  },
  {
    path: `/invite`,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "ReferralPage" */ './pages/ReferralPage/ReferralPage'
        ),
    ),
    translated: true,
  },
  /*
   * The new referral landing page, at its temporary address. Absent from the
   * production bundle - route and chunk both - until it takes over /invite.
   * See pages/Referral/paths.ts, and delete this whole guard at the flip.
   *
   * The env test is written out here rather than imported as a boolean so
   * webpack folds it while parsing and never follows the import() below.
   */
  ...(process.env.environment !== 'production'
    ? [
        {
          path: [`${REFERRAL_BASE}/:code/plans`, `${REFERRAL_BASE}/plans`],
          component: loadable(
            () =>
              import(
                /* webpackChunkName: "ReferralPlanPickerPage" */ './pages/Referral/PlanPickerPage'
              ),
          ),
          translated: true,
        },
        {
          path: [`${REFERRAL_BASE}/:code`, REFERRAL_BASE],
          component: loadable(
            () =>
              import(
                /* webpackChunkName: "NewReferralPage" */ './pages/Referral/ReferralPage'
              ),
          ),
          translated: true,
        },
      ]
    : []),
  /*
   * The Global Food Report campaign page. Absent from the production bundle -
   * route and chunk both - until the report launches. Delete this whole guard
   * at the flip; the page itself is finished.
   *
   * The env test is written out here rather than imported as a boolean so
   * webpack folds it while parsing and never follows the import() below.
   */
  ...(process.env.environment !== 'production'
    ? [
        {
          path: '/global-food-report',
          component: loadable(
            () =>
              import(
                /* webpackChunkName: "GlobalFoodReport" */ './pages/GlobalFoodReport/GlobalFoodReportPage'
              ),
          ),
          translated: true,
        },
      ]
    : []),
  {
    path: '/plan-quiz',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "PlanQuizPage" */ './pages/PlanQuizPage/PlanQuizPage'
        ),
    ),
    translated: true,
  },
  {
    path: '/nutrition-explained',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "NutritionStart" */ './pages/NutritionExplained/NutritionStart'
        ),
    ),
  },
  {
    path: '/nutrition-explained/experts',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "AdvisoryBoard" */ './pages/NutritionExplained/AdvisoryBoard'
        ),
    ),
  },
  {
    path: ['/nutrition-explained/videos', '/nutrition-explained/video/:video'],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "NutritionVideos" */ './pages/NutritionExplained/NutritionVideos'
        ),
    ),
  },
  {
    path: [
      '/nutrition-explained/category/:category',
      '/nutrition-explained/recipes/',
    ],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "NutritionCategory" */ './pages/NutritionExplained/NutritionCategory/NutritionCategory'
        ),
    ),
    translated: true,
  },
  {
    path: '/nutrition-explained/recipe/:slug',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "NutritionRecipe" */ './pages/NutritionExplained/NutritionRecipe'
        ),
    ),
    translated: true,
  },
  {
    path: [
      '/nutrition-explained/page/:pageNumber',
      '/nutrition-explained/archive/:pageNumber',
    ],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "NutritionArticlesAll" */ './pages/NutritionExplained/NutritionArticlesAll'
        ),
    ),
  },
  {
    path: '/nutrition-explained/search/:query',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "NutritionSearchResults" */ './pages/NutritionExplained/NutritionSearchResults'
        ),
    ),
  },
  {
    path: '/nutrition-explained/:slug',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "NutritionArticle" */ './pages/NutritionExplained/NutritionArticle'
        ),
    ),
    translated: true,
  },
  {
    path: '/news/:slug',
    component: loadable(() => import('./pages/DatoNativeAd/DatoNativeAd')),
    translated: true,
  },
  {
    path: '/features',
    component: loadable(() => import('./pages/FeaturesPage/FeaturesPage')),
    translated: true,
  },
  {
    path: [
      '/page/:slug',
      '/press',
      '/lifesum-games',
      '/disclaimer',
      '/ambassadorswe',
      '/germany',
    ],
    component: loadable(() => import('./pages/DatoPage/DatoPage')),
    translated: true,
  },
  {
    path: '/partner/:slug/*',
    component: loadable(() => import('./pages/PartnerPage/CmsPartnerPage')),
    translated: true,
  },
  {
    path: ['/gympass', '/gympass/signup'],
    component: loadable(
      () => import(/* webpackChunkName: "Gympass" */ './pages/Gympass/Gympass'),
    ),
  },
  {
    path: ['/blog', '/en/blog'],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "BlogListPage" */ './pages/Blog/BlogListPage'
        ),
    ),
    translated: true,
  },
  {
    path: ['/blog/:slug', '/en/blog/:slug'],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "BlogPostPage" */ './pages/Blog/BlogPostPage'
        ),
    ),
    translated: true,
  },
  {
    path: ['/health', '/en/health'],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "Glp1ListPage" */ './pages/Glp1/Glp1ListPage'
        ),
    ),
    translated: true,
  },
  {
    path: ['/health/:slug', '/en/health/:slug'],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "Glp1Article" */ './pages/Glp1/Glp1ArticlePage'
        ),
    ),
    translated: true,
  },
]
  .map(({ path, ...rest }) =>
    Array.isArray(path)
      ? path.map((path) => ({ path, ...rest }))
      : { path, ...rest },
  )
  .flat()

export const clientRoutes = [
  {
    path: ['/redeem/:slug', '/influencer/:slug'],
    component: loadable(() => import('./pages/Redeem/DatoRedeemPage')),
    translated: true,
  },
  {
    path: ['/deep', '/deep/*'],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "FallbackPage" */ './pages/FallbackPage/FallbackPage'
        ),
    ),
  },
  {
    path: ['/work', '/insights'],
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "LifesumForWork" */ './pages/LifesumForWork/LifesumForWork'
        ),
    ),
  },
  {
    path: '/email/*',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "EmailLandingPage" */ './pages/EmailLandingPage'
        ),
    ),
  },
  {
    path: '/verify/:code',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "VerifyPage" */ './pages/VerifyPage/VerifyPage'
        ),
    ),
    translated: true,
  },
  {
    path: '/quiz',
    component: loadable(
      () => import(/* webpackChunkName: "QuizAd" */ './pages/QuizAd/QuizAd'),
    ),
  },
]
  .map(({ path, ...rest }) =>
    Array.isArray(path)
      ? path.map((path) => ({ path, ...rest }))
      : { path, ...rest },
  )
  .flat()

export default routes
